const countFormatter = new Intl.NumberFormat();

// Rates arrive as fractions in [0, 1]. null means the backend could not
// measure the rate (denominator 0), which must read as "—", never as "0.0%".
export const formatRate = (value: number | null): string => {
  if (value === null || !Number.isFinite(value)) return "—";
  return `${(value * 100).toFixed(1)}%`;
};

export const formatCount = (value: number): string =>
  countFormatter.format(Math.round(value));
